import * as React from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

interface AuthCardProps {
  title: string
  description: string
  children: React.ReactNode
}

export function AuthCard({ title, description, children }: AuthCardProps) {
  return (
    <div
      className="min-h-screen w-screen flex items-center justify-center p-6"
      style={{
        background: '#08080e',
      }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 70% 55% at 50% 55%, rgba(0,234,255,0.08) 0%, transparent 70%)',
        }}
      />
      <Card
        className="w-full max-w-md relative"
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(0,234,255,0.2)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <CardHeader className="text-center">
          <CardTitle
            className="text-lg md:text-2xl"
            style={{
              fontFamily: "'Russo One', sans-serif",
              color: '#fff',
            }}
          >
            {title}
          </CardTitle>
          <CardDescription
            className="text-sm md:text-base"
            style={{ color: 'rgba(255,255,255,0.65)' }}
          >
            {description}
          </CardDescription>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  )
}
